import { render, staticRenderFns } from "./AlertCircleOutline.vue?vue&type=template&id=4aed4486"
import script from "./AlertCircleOutline.vue?vue&type=script&lang=js"
export * from "./AlertCircleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports